import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import withStyles from '@material-ui/core/styles/withStyles';

import { createFlyerThumbPath } from 'utils';

const styles = (theme) => ({
  imageContainer: {
    flex: '1 1 auto',
    position: 'relative',
    background: theme.colors.flyerBackground || theme.colors.darkGrey,
  },
  image: {
    padding: theme.spacing(2),
    display: 'block',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '100%',
    maxHeight: '100%',
  },
  // same placement as the @doveconviene/react-sf-viewer loader, so the switch to it is not noticeable
  logo: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

const ViewerSkeleton = ({
  intl: { locale },
  flyerId,
  classes,
  className,
  hideThumbnail,
  logoUrl,
}) => {
  let content = null;
  if (!hideThumbnail) {
    content = <img className={classes.image} src={createFlyerThumbPath(locale, flyerId)} alt="" />;
  } else if (logoUrl) {
    content = <img className={classes.logo} src={logoUrl} alt="" />;
  }

  return <div className={`${classes.imageContainer} ${className}`}>{content}</div>;
};

ViewerSkeleton.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  intl: PropTypes.shape({
    locale: PropTypes.string.isRequired,
  }).isRequired,
  flyerId: PropTypes.string.isRequired,
  className: PropTypes.string,
  hideThumbnail: PropTypes.bool,
  logoUrl: PropTypes.string,
};

ViewerSkeleton.defaultProps = {
  className: null,
  hideThumbnail: false,
  logoUrl: null,
};

const WithStylesViewerSkeleton = withStyles(styles)(ViewerSkeleton);

export default injectIntl(WithStylesViewerSkeleton);
